import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface LongArrowDownRightIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const LongArrowDownRightIcon = ({ className, ...props }: LongArrowDownRightIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.25 18.25L16.75 14.75L13.25 11.25"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M16.75 14.75H8.75C7.64543 14.75 6.75 13.8546 6.75 12.75V5.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default LongArrowDownRightIcon;
